<ng-container *transloco="let t">
  <app-page-template [showBreadcrumbs]="false">
    <div class="mb-4 mb-xxl-3 hide-on-13inch-range">
      <app-hero-alt>
        <div slot="slotText">
          <div class="pb-3">
            <h1 class="main-hero-title font-6xl light">All events</h1>
          </div>
          <div class="pb-0 pb-md-4 main-hero-subtitle">
            <h3 class="light">Track your journey, explore new challenges, and find the race
              that inspires you to move.</h3>
          </div>
        </div>
      </app-hero-alt>
    </div>
    <ng-template [ngTemplateOutlet]="searchFrom"></ng-template>
    @if (eventMapVisible) {
      <ng-template [ngTemplateOutlet]="eventMap"></ng-template>
    } @else {
      <ng-template [ngTemplateOutlet]="eventList"></ng-template>
    }
  </app-page-template>

  <ng-template #searchFrom>
    <form #filterRacesForm="ngForm">
      <!--      LG screen filter view-->
      <div class="d-none d-xxl-flex flex-column">
        <div
          class="d-flex px-3 px-md-0 flex-row justify-content-start justify-content-lg-center align-items-xxl-center filter-box mb-md-4">
          <div class="ps-2 pe-2 pe-md-4 px-md-0 me-0 me-md-3 search-wrapper">
            <app-search [searchBarClass]="'extra-small'" (searchQuery)="handleInput($event)" [inputValue]="name"
                        [placeholder]="t('search.placeholder.races')"/>
          </div>
          <div class="explore-filter__grid">
            <div class="explore-filter__grid-inner">
              <div class="d-flex">
                <div class="d-none d-md-flex ms-2 ms-md-0 flex-grow-1 flex-lg-grow-0">
                  <app-date-range-selector (dateChanged)="dateChanged($event)"
                                           [maxDate]="calendarType === EventItemType.FINISHED ? initialDate: undefined"
                                           [minDate]="calendarType === EventItemType.UPCOMING ? initialDate : undefined"
                                           [toDate]="dateTo" [fromDate]="dateFrom"/>
                </div>
                <div class="ms-2 me-2 flex-grow-1 flex-lg-grow-0">
                  <ng-container *ngTemplateOutlet="raceLengthDropdown;
                    context: {
                      selectedRange: selectedRange,
                      lengthRanges: lengthRanges,
                      onLengthRangeSelect: onLengthRangeSelect,
                      environment: environment,
                      t: t
                    }"></ng-container>
                </div>
              </div>
              <div class="position-relative pe-2 ps-2">
                <ng-container *ngTemplateOutlet="sportDropdown;
                context: {
                  sportId: sportId,
                  sportsForSearch: sportsForSearch,
                  onSportSelect: onSportSelect,
                  t: t
                }"></ng-container>
              </div>
              <div class="position-relative pe-2 ps-2">
                <ng-container *ngTemplateOutlet="countryDropdown;
                  context: {
                    countryId: countryId,
                    countriesForSearch: countriesForSearch,
                    onCountrySelect: onCountrySelect,
                    t: t
                  }"></ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="pb-4 px-4 d-flex d-md-none">
          <app-date-range-selector (dateChanged)="dateChanged($event)"
                                   [maxDate]="calendarType === EventItemType.FINISHED ? initialDate: undefined"
                                   [minDate]="calendarType === EventItemType.UPCOMING ? initialDate : undefined"
                                   [toDate]="dateTo" [fromDate]="dateFrom" style="width: 100%;"/>
        </div>
      </div>
      <!--      XS screen filter view-->
      <div class="d-flex d-xxl-none flex-column px-4 pt-2">
        <div class="d-flex gap-2 pb-3">
          <div style="flex: 1.5;">
            <app-search [searchBarClass]="'extra-small'" (searchQuery)="handleInput($event)" [inputValue]="name"
                        [placeholder]="t('search.placeholder.races')"/>
          </div>
          <div style="flex: 1;">
            <app-date-range-selector (dateChanged)="dateChanged($event)"
                                     [maxDate]="calendarType === EventItemType.FINISHED ? initialDate: undefined"
                                     [minDate]="calendarType === EventItemType.UPCOMING ? initialDate : undefined"
                                     [toDate]="dateTo" [fromDate]="dateFrom" [wrapperWidth]="'auto'"/>
          </div>
        </div>
        <div class="d-flex gap-2 pb-2">
          <div style="flex: 1.4;">
            <ng-container *ngTemplateOutlet="raceLengthDropdown;
                    context: {
                      selectedRange: selectedRange,
                      lengthRanges: lengthRanges,
                      onLengthRangeSelect: onLengthRangeSelect,
                      environment: environment,
                      t: t
                    }"></ng-container>
          </div>
          <div style="flex: 1;">
            <ng-container *ngTemplateOutlet="sportDropdown;
                context: {
                  sportId: sportId,
                  sportsForSearch: sportsForSearch,
                  onSportSelect: onSportSelect,
                  t: t
                }"></ng-container>
          </div>
          <div style="flex: 1;">
            <ng-container *ngTemplateOutlet="countryDropdown;
                  context: {
                    countryId: countryId,
                    countriesForSearch: countriesForSearch,
                    onCountrySelect: onCountrySelect,
                    t: t
                  }"></ng-container>
          </div>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #eventList>
    <div class="padding-bottom-92 pb-300-100">
      <section class="next-race-section upper-section-background">
        <div class="container">
          <app-loader [isLoading]="isLoading"></app-loader>
          <section>
            @if (listOfEvents.length ?? 0 > 0) {
              <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3">
                @for (item of listOfEvents;track trackByFn) {
                  <div class="col mb-4">
                    <app-event-grid-item-with-image-alt [eventItem]="item" [countries]="countries" [isLanding]="true"
                                                        (onRightButtonClickCallback)="goToEventDetailsPage(item, this.calendarType === EventItemType.FINISHED)"
                                                        [languages]="languages"
                                                        [isFinishedEvent]="this.calendarType === EventItemType.FINISHED"/>
                  </div>
                }
              </div>
            } @else {
              <app-empty-state/>
            }
            @if ((listOfEvents.length ?? 0 > 0) && hasMoreEvents) {
              <div class="d-flex justify-content-center load-more-wrapper">
                <app-button-alt [text]="t('app.common.load.more.events')" [borderColor]="'var(--teal-500)'"
                                [textColor]="'var(--grey-neutral-800)'" (onClickCallback)="loadMore()"
                                [buttonColor]="'transparent'"/>
              </div>
            }
          </section>
        </div>
      </section>
      @if ((listOfEvents.length ?? 0 > 0) && showFabButton) {
        <div (click)="scrollToTop()" class="scroll-to-top">
          <i class="bi bi-arrow-up"></i>
        </div>
      }
    </div>
  </ng-template>

  <ng-template #eventMap>
    <div>
      <section class="pb-300-100">
        <div class="container">
          <app-loader [isLoading]="isLoading"></app-loader>
          <section>
            <app-leaflet-maps-wrapper [lat]="lat" [lng]="lng" [points]="waypointList" [languages]="languages"
                                      [countries]="countries" [mapOnEventCalendar]="true" [increaseMapHeight]="true"/>
          </section>
        </div>
      </section>
    </div>
  </ng-template>
</ng-container>

<ng-template #sportDropdown let-sportId="sportId" let-sportsForSearch="sportsForSearch"
             let-onSportSelect="onSportSelect" let-t="t">
  <div ngbDropdown class="dropdown-small" container="body">
    <div class="dropdown" id="sportsDropdown" ngbDropdownToggle>
      {{sportId ? t('app.common.sports.' + sportId) : t("explore.sports")}}
    </div>
    <div ngbDropdownMenu aria-labelledby="raceLengthDropdown" class="scrollable">
      <button ngbDropdownItem (click)="onSportSelect?.call(this)">
        {{t("app.common.all")}}
        @if (sportId === undefined) {
          <i class="bi bi-check"></i>
        }
      </button>
      @for (sport of sportsForSearch;track sport) {
        <button ngbDropdownItem (click)="onSportSelect?.call(this, sport.id)">
          {{t('app.common.sports.' + sport.id)}}
          @if (sportId === sport.id) {
            <i class="bi bi-check"></i>
          }
        </button>
      }
    </div>
  </div>
</ng-template>

<ng-template #countryDropdown let-countryId="countryId" let-countriesForSearch="countriesForSearch"
             let-onCountrySelect="onCountrySelect" let-t="t">
  <div ngbDropdown class="dropdown-small" container="body">
    <div class="dropdown" id="countryDropdown" ngbDropdownToggle>
      {{countryId ? t('app.common.country.' + countryId) : t("explore.country")}}
    </div>
    <div ngbDropdownMenu aria-labelledby="countryDropdown" class="scrollable">
      <button ngbDropdownItem (click)="onCountrySelect?.call(this)">
        {{t("app.common.all")}}
        @if (countryId === undefined) {
          <i class="bi bi-check"></i>
        }
      </button>
      @for (country of countriesForSearch;track country) {
        <button ngbDropdownItem (click)="onCountrySelect?.call(this, country.id)">
          {{t('app.common.country.' + country.id)}}
          @if (countryId === country.id) {
            <i class="bi bi-check"></i>
          }
        </button>
      }
    </div>
  </div>
</ng-template>

<ng-template #raceLengthDropdown let-selectedRange="selectedRange" let-lengthRanges="lengthRanges"
             let-onLengthRangeSelect="onLengthRangeSelect" let-environment="environment" let-t="t">

  <div ngbDropdown class="dropdown-small" container="body">
    <div class="dropdown" id="raceLengthRangeDropdown" ngbDropdownToggle>
      @if (selectedRange) {
        {{
          selectedRange.to && selectedRange.from ? selectedRange.from + " - " + selectedRange.to : ""
        }}{{
          selectedRange.to && !selectedRange.from ? t("explore.races.length.to") + " " + selectedRange.to : ""
        }}{{
          !selectedRange.to && selectedRange.from ? t("explore.races.length.over") + " " + selectedRange.from : ""
        }}{{environment.lengthDropdownMeasurementUnit}}
      } @else {
        {{t("explore.races.length")}}
      }
    </div>

    <div ngbDropdownMenu aria-labelledby="raceLengthRangeDropdown">
      <button ngbDropdownItem (click)="onLengthRangeSelect?.call(this)">
        {{t("app.common.all")}}
        @if (selectedRange === undefined) {
          <i class="bi bi-check"></i>
        }
      </button>
      @for (length of lengthRanges;track length) {
        <button ngbDropdownItem (click)="onLengthRangeSelect?.call(this, length)">
          {{length.to && length.from ? length.from + " - " + length.to : ""}}
          {{length.to && !length.from ? t("explore.races.length.to") + " " + length.to : ""}}
          {{!length.to && length.from ? t("explore.races.length.over") + " " + length.from : ""}}
          {{environment.lengthDropdownMeasurementUnit}}
          @if (selectedRange === length) {
            <i class="bi bi-check"></i>
          }
        </button>
      }
    </div>
  </div>
</ng-template>

